import { IParsedImage } from '@components/typescript';

const useImageSources = (img: IParsedImage) => {
  const getImageSrc = (breakpoint) => {
    if (!img?.image) return '';
    const { image } = img;
    if (typeof image[breakpoint] !== 'string' && image[breakpoint]?.path) return image[breakpoint].path;
    if (typeof image[breakpoint] === 'string' && image[breakpoint]) return image[breakpoint];
    if (image.desktop && typeof image.desktop !== 'string' && image.desktop.path) return image.desktop.path;
    if (image.tablet && typeof image.tablet !== 'string' && image.tablet?.path) return image.tablet.path;
    if (image.mobile && typeof image.mobile !== 'string' && image.mobile.path) return image.mobile.path;
    return image[breakpoint] || image.desktop;
  };

  const getBlurSrc = () => {
    if (!img?.blur?.mobile) return '';
    const { mobile } = img.blur;
    return typeof mobile !== 'string' ? mobile.path || '' : mobile;
  };

  const getSrcs = (breakpoint) => ({
    imageSrc: typeof window !== 'undefined' ? getImageSrc(breakpoint) : getBlurSrc(),
    blurSrc: getBlurSrc(),
  });

  return { getSrcs };
};

export default useImageSources;
